$(document).ready(function () {
    $('.bxslider').each(function () {
        if ($(this).find('li').length > 1) {
            var Slider = $(this).bxSlider({
                adaptiveHeight: true,
                preloadImages: 'all',
                onSliderLoad: function () {
                    $(this).parents('.bxslider-wrapper').show(function () {
                        Slider.redrawSlider();
                    });
                }
            });
        } else {
            $(this).parents('.bxslider-wrapper').show();
        }
    });
});